import * as ASSESSMENT from './actions.js'

// define initial state of all possible properties
export const initialState = {
  error: false,
  loading: false,
  questionnaireResponse: {},
  allergy: {
    type: 'food',
    name: 'apple',
    anaphylaxis: 'no',
    description: "doesn't like apples"
  },
  interactions: []
}

export default function reducer (state = initialState, action) {
  // modify state based on action types
  switch (action.type) {
    case ASSESSMENT.ASSESSMENT:
      return {
        ...state,
        loading: true,
        assessment: {}
      }
    case ASSESSMENT.ASSESSMENT_SUCCESS:
      if (action.questionnaireResponse.immunizations) {
        return {
          ...state,
          loading: false,
          questionnaireResponse: {
            ...state.questionnaireResponse,
            immunizations: action.questionnaireResponse.immunizations
          }
        }
      }

      return {
        ...state,
        loading: false,
        questionnaireResponse: action.questionnaireResponse
      }

    case ASSESSMENT.UPDATE_MEDICATIONS:
      return {
        ...state,
        loading: false,
        questionnaireResponse: {
          ...state.questionnaireResponse,
          medications: action.payload
        }
      }
    case ASSESSMENT.ASSESSMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case 'UPDATE_INTERACTIONS':
      return {
        ...state,
        interactions: action.interactions
      }
    default:
      return state
  }
}
